import { SKIPPED, computeStackTrace, objectEntries, addTelemetryError, isExperimentalFeatureEnabled, ExperimentalFeature, } from '@datadog/browser-core';
export function startSourceCodeContext(hooks) {
    if (!isExperimentalFeatureEnabled(ExperimentalFeature.SOURCE_CODE_CONTEXT)) {
        return;
    }
    const browserWindow = window;
    const contextByFile = new Map();
    function buildContextByFile() {
        if (!browserWindow.DD_SOURCE_CODE_CONTEXT) {
            return;
        }
        objectEntries(browserWindow.DD_SOURCE_CODE_CONTEXT).forEach(([stack, context]) => {
            const stackTrace = computeStackTrace({ stack });
            const firstFrame = stackTrace.stack[0];
            if (!firstFrame.url) {
                addTelemetryError('Source code context: missing frame url', { stack });
                return;
            }
            // don't overwrite existing context
            if (!contextByFile.has(firstFrame.url)) {
                contextByFile.set(firstFrame.url, context);
            }
        });
        browserWindow.DD_SOURCE_CODE_CONTEXT = {};
    }
    buildContextByFile();
    hooks.register(0 /* HookNames.Assemble */, ({ domainContext, rawRumEvent }) => {
        buildContextByFile();
        const url = getSourceUrl(domainContext, rawRumEvent);
        if (url) {
            const context = contextByFile.get(url);
            if (context) {
                return {
                    type: rawRumEvent.type,
                    service: context.service,
                    version: context.version,
                };
            }
        }
        return SKIPPED;
    });
}
function getSourceUrl(domainContext, rawRumEvent) {
    var _a, _b;
    if (rawRumEvent.type === 'long_task' && rawRumEvent.long_task.entry_type === 'long-animation-frame') {
        return (_a = rawRumEvent.long_task.scripts[0]) === null || _a === void 0 ? void 0 : _a.source_url;
    }
    let stack;
    if ('handlingStack' in domainContext) {
        stack = domainContext.handlingStack;
    }
    if (rawRumEvent.type === 'error' && rawRumEvent.error.stack) {
        stack = rawRumEvent.error.stack;
    }
    const stackTrace = computeStackTrace({ stack });
    return (_b = stackTrace.stack[0]) === null || _b === void 0 ? void 0 : _b.url;
}
//# sourceMappingURL=sourceCodeContext.js.map